const MAX_CACHED_BLOBS = 20;
const blobCache = new Map<string, Blob>();

const cacheBlob = (url: string, blob: Blob) => {
  if (blobCache.size >= MAX_CACHED_BLOBS) {
    const oldestUrl = blobCache.keys().next().value;
    if (oldestUrl) blobCache.delete(oldestUrl);
  }
  blobCache.set(url, blob);
};

export const useBlobPreview = () => {
  const preview = async ({ url }: { url: string }) => {
    if (!Boolean(url)) {
      return;
    }

    try {
      let blob = blobCache.get(url);

      if (!blob) {
        const response = await fetch(url, {
          headers: {
            Accept: "application/pdf",
          },
        });

        if (!response.ok) {
          throw new Error("Network response was not ok.");
        }

        blob = await response.blob();
        cacheBlob(url, blob);
      }

      const fileURL = URL.createObjectURL(blob);

      return { fileURL, blob };
    } catch (error) {
      throw error;
    }
  };

  return { preview };
};
